import { render, staticRenderFns } from "./AttachmentPreview.vue?vue&type=template&id=1b823fbe&scoped=true"
import script from "./AttachmentPreview.vue?vue&type=script&lang=js"
export * from "./AttachmentPreview.vue?vue&type=script&lang=js"
import style0 from "./AttachmentPreview.vue?vue&type=style&index=0&id=1b823fbe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b823fbe",
  null
  
)

export default component.exports